import clsx from "clsx";
import { Link } from "react-router-dom";

/**
 * Empty state when the signed-in user has no profile document yet.
 */
export default function ProfileNotFound() {
  return (
    <div className="flex h-full items-center justify-center bg-gray-50 p-8">
      <div className="text-center">
        <h2 className="mb-2 text-xl font-semibold text-gray-900">No profile found</h2>
        <p className="mb-6 text-gray-600">Please complete your onboarding to view your profile.</p>
        <Link
          to="/onboarding"
          className={clsx(
            "inline-block rounded-xl bg-pink-600 px-6 py-3 text-sm font-semibold text-white",
            "hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2"
          )}
          data-testid="complete-onboarding-link"
        >
          Complete onboarding
        </Link>
      </div>
    </div>
  );
}
